import React from "react";
import { X, LogOut, Home, User, History, Edit3, CalendarDays } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar({ sidebarOpen, setSidebarOpen, onLogout }) {
  const location = useLocation();

  const navigation = [
    { name: "Dashboard", icon: Home, route: "/" },
    { name: "My Profile", icon: User, route: "/profile" },
    { name: "Edit Details", icon: Edit3, route: "/edit-details" },
    { name: "Apply Leave", icon: CalendarDays, route: "/leave-application" },
    { name: "Allocation History", icon: History, route: "/hostelhistory" },
  ];

  return (
    <aside
      className={`fixed inset-y-0 left-0 w-64 bg-white shadow-lg transform transition-transform duration-300 z-30 ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } md:translate-x-0`}
    >
      <div className="flex items-center justify-between h-16 px-4 border-b">
        <h2 className="text-lg font-semibold text-blue-700">GBU Hostel</h2>
        <button
          className="md:hidden p-2"
          onClick={() => setSidebarOpen(false)}
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <nav className="flex-1 px-4 py-4 space-y-1">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.route}
            onClick={() => setSidebarOpen(false)} // Close sidebar on click
            className={`flex items-center w-full px-3 py-2 rounded-lg transition
              ${
                location.pathname === item.route
                  ? "bg-blue-100 text-blue-700 font-medium"
                  : "text-gray-700 hover:bg-blue-50"
              }`}
          >
            <item.icon className="mr-3 h-5 w-5" />
            {item.name}
          </Link>
        ))}

        <button
          onClick={onLogout}
          className="flex items-center w-full px-3 py-2 text-red-600 hover:bg-red-50 rounded-lg transition mt-4"
          type="button"
        >
          <LogOut className="mr-3 h-5 w-5" />
          Logout
        </button>
      </nav>
    </aside>
  );
}
